export enum TipoBlocoRegraEnum {
    TIPO_E = 'E',
    TIPO_OU = 'OU',
}
